module.exports = {"pt-BR":{"table-header":{"actions":"Ações"}}}